import React, { useState, useEffect, useRef, useCallback } from 'react';
// import mainimg from "../../assets/a-soccer-field.jpeg";
import ReactPlayer from 'react-player';
import { Play, Pause, Volume2, VolumeX, ChevronLeft, RotateCcw, RotateCw, Maximize, Minimize } from "lucide-react";
import logo from "../assets/2ndTeam.jpg";
import trailercover from "../assets/trailercoverv4.jpeg"
import { useOnScreen } from "../useOnScreen"; // wherever you save the hook
import { Card, CardText, Button } from "react-bootstrap";
import StoryDonut from "../StoryDonut";
import AnimatedGanttChart from "../AnimatedGanttChart"; // adjust path if needed
import FlipCard from '../FlipCard';
import Nick from '../assets/NicholasOrtiz2.jpeg';
import Nico from '../assets/Nicolas.jpeg';
import Kent from '../assets/Kent.jpeg';
import Rodrigo from '../assets/Rodrigo.jpeg';
import storyBG from '../assets/poster.jpg';
import hero from '../assets/hero.jpeg';
import drug from '../assets/drug.jpeg';
import closeup from '../assets/closeup.jpeg';
import brawl from '../assets/brawl.jpeg';
import broken from '../assets/broken.jpeg';
import redbg from '../assets/redbgv5.jpeg';
import redbgf from '../assets/redbgv5.jpeg';
import alleybrawl from '../assets/alleybrawl.jpeg'
import darkfigure from '../assets/darkfigure.jpeg'
import drugdeal from '../assets/drugdeal.jpeg'

import ActionRevenueLineGraph from '../ActionRevenueLineGraph';
import DomesticVsInternational from '../DomesticVsInternational';
import CompsChart from '../CompsChart';
import UseOfFundsDonut from '../UseofFundsDonut';
import Dial from '../Dial';
import TeamRevealCard from '../TeamRevealCard';
import FilmCarousel from '../FilmCarousel';
import FinancialProjections from '../FinancialProjections';
import ImagineCast from '../ImagineCast';

export default function PitchDeck() {
  const [text1Ref, text1Visible] = useOnScreen();
  const [logoRef, logoVisible] = useOnScreen();
  const [text2Ref, text2Visible] = useOnScreen();
  const [storyRef, storyVisible] = useOnScreen();
const [castRef, castVisible] = useOnScreen();
const [teamRef, teamVisible] = useOnScreen();
const [partnerRef, partnerVisible] = useOnScreen();
const [marketRef, marketVisible] = useOnScreen();
const [schedRef, schedVisible] = useOnScreen();
const [donutRef, donutVisible] = useOnScreen();
const [revenueRef, revenueVisible] = useOnScreen();
const [domsvsintRef, domsvsintVisible] = useOnScreen();
const [compsRef, compsVisible] = useOnScreen();
const [story1Ref, story1Visible] = useOnScreen();
const [story2Ref, story2Visible] = useOnScreen();
const [story3Ref, story3Visible] = useOnScreen();
const [story4Ref, story4Visible] = useOnScreen();
const [moodRef, moodVisible] = useOnScreen();

    const [cardVisible, setCardVisible] = useState(false);
    const [media, setMedia] = useState({});
    const [savedTime, setSavedTime] = useState(0);
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const playerRef = useRef(null);
    const wrapperRef = useRef(null);
      const sliderRef = useRef(null);
    const [muted, setMuted] = useState(false);
    const [volume, setVolume] = useState(0.8);
    const [played, setPlayed] = useState(0);
    const [hasStarted, setHasStarted] = useState(false);
    const [showControls, setShowControls] = useState(false);

    const inactivityTimeoutRef = useRef(null);
    const [hoverX, setHoverX] = useState(null);
    const [hoverTime, setHoverTime] = useState(null);
    const [showVolumeSlider, setShowVolumeSlider] = React.useState(false);
    const [isFullscreen, setIsFullscreen] = React.useState(false);
    const lastPlayedTimeRef = useRef(0);
    const [showPoster, setShowPoster] = useState(true);
    const [bgStarted, setBgStarted] = useState(false);
    const bgVideoRef = useRef(null);

    useEffect(() => {
  if (bgStarted && bgVideoRef.current) {
    const vid = bgVideoRef.current;
    vid.src = `${CF_BASE}/pdbgafter.mp4`;
    vid.loop = true;
    vid.load();
    vid.play();
  }
}, [bgStarted]);

//     const handleEnded = () => {
//   setIsPlaying(false);
//   setShowControls(true);
//   setBgStarted(true);
// };

    const togglePlayPause = () => {
  const internal = playerRef.current?.getInternalPlayer();
  if (!internal) return;

  if (isPlaying) {
    internal.pause();
  } else {
    internal.play();
  }
};


const handlePlay = () => {
  setIsPlaying(true);
  setHasStarted(true);
  setShowControls(true);
};

const handlePause = () => {
  setIsPlaying(false);
  setShowControls(true); // keep controls visible when paused
};

const handleEnded = () => {
  setIsPlaying(false);
  setShowControls(true);
   setBgStarted(true);
};


const handleToggleFullscreen = () => {
  const el = wrapperRef.current;
  if (!el) return;

  if (!document.fullscreenElement) {
    el.requestFullscreen?.();
  } else {
    document.exitFullscreen?.();
  }
};

   useEffect(() => {
    const handleUserActivity = () => resetInactivityTimer();
  
    window.addEventListener('mousemove', handleUserActivity);
    window.addEventListener('touchstart', handleUserActivity);
  
    resetInactivityTimer(); // Start timer on mount
  
    return () => {
      window.removeEventListener('mousemove', handleUserActivity);
      window.removeEventListener('touchstart', handleUserActivity);
      if (inactivityTimeoutRef.current) {
        clearTimeout(inactivityTimeoutRef.current);
      }
    };
  }, []);

  const resetInactivityTimer = () => {
  if (!isPlaying) return; // 👈 don’t auto-hide when paused

  setShowControls(true);

  clearTimeout(inactivityTimeoutRef.current);
  inactivityTimeoutRef.current = setTimeout(() => {
    setShowControls(false);
  }, 3000);
};

  const [duration, setDuration] = React.useState(0);
  const handleDuration = (dur) => {
    setDuration(dur);
  };
  const hideTimeoutRef = useRef(null);

  function formatTime(seconds) {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    
    if (hrs > 0) {
      return `${hrs}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    } else {
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    }
  }

    const currentTime = played * duration;
  const totalTime = duration;
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);


  const handleRewind15 = () => {
    const currentTime = playerRef.current.getCurrentTime();
    playerRef.current.seekTo(Math.max(currentTime - 15, 0), 'seconds');
  };
  
  const handleForward15 = () => {
    const currentTime = playerRef.current.getCurrentTime();
    playerRef.current.seekTo(Math.min(currentTime + 15, duration), 'seconds');
  };

    const toggleMute = () => {
    setMuted((prev) => {
      const newMuted = !prev;
      if (videoRef.current) {
        videoRef.current.muted = newMuted;
      }
      return newMuted;
    });
  };

    const handleProgress = (state) => {
    setPlayed(state.played);
    lastPlayedTimeRef.current = state.played;
    localStorage.setItem(
  `video-player-time-${videoUrl}`,
  state.played.toString()
);

  };

   const sectionRef = useRef(null);
  const [triggered, setTriggered] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setTriggered(true); },
      { threshold: 0.3 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);


  const videoWrapperRef = useRef(null);
const [videoVisible, setVideoVisible] = useState(false);
useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => { if (entry.isIntersecting) setVideoVisible(true); },  // 👈
    { threshold: 0.3 }
  );
  if (videoWrapperRef.current) observer.observe(videoWrapperRef.current);  // 👈
  return () => observer.disconnect();
}, []);

    const videoUrl = media['RRPitch']?.videourl; 

   const CF_BASE = "https://d3duw5o0obopn7.cloudfront.net";


   


  return (
    <div style={{ marginTop: '7%', marginBottom: '7%', minHeight: '100vh' }}>
      {/* <img
        src={mainimg}
        alt=""
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
        }}
      /> */}

  <div>
<video
  ref={bgVideoRef}
  autoPlay
  muted
  playsInline
  src={`${CF_BASE}/bgbeforev9.mp4`}
  style={{
    position: 'fixed',
    top: 0, left: 0,
    width: '100%', height: '100%',
    objectFit: 'cover',
    zIndex: -1,
  }}
  onEnded={() => {
    const vid = bgVideoRef.current;
    vid.src = `${CF_BASE}/pdbgafterv2.mp4`;
    vid.loop = true;
    vid.load();
    vid.play();
  }}
/>
  </div>

      {/* First Text */}
      <div className="d-flex justify-content-center">
        <div
          ref={text1Ref}
          style={{
            opacity: text1Visible ? 1 : 0,
            transition: "opacity 0.9s ease",
            transitionDelay: text1Visible ? "2s" : "0s", 
            // background: "rgba(96,85,61,0.7)",
            // backdropFilter: "blur(5px)",
            // WebkitBackdropFilter: "blur(5px)",
            borderRadius: "30px",
            padding: "0.2rem 0.6rem",
            // marginBottom: '1rem',
            
          }}
        >
          <h9 style={{ 
            margin: 0,}}>Shared Fate</h9>
        </div>
      </div>

<div className="d-flex justify-content-center">
  <div
    ref={text1Ref}
    style={{
      opacity: text1Visible ? 1 : 0,
      transition: "opacity 0.9s ease",
      transitionDelay: text1Visible ? "2s" : "0s",
      borderRadius: "30px",
      textAlign: 'center',
      maxWidth: '1000px',
      padding: "1.5rem",
      marginBottom: '2rem',
      position: 'relative',   // ← needed
      overflow: 'hidden',     // ← clips video to div shape
        maskImage: `linear-gradient(to right, transparent, white 15%, white 85%, transparent), 
            linear-gradient(to bottom, transparent, white 10%, white 90%, transparent)`,
WebkitMaskImage: `linear-gradient(to right, transparent, white 15%, white 85%, transparent), 
                  linear-gradient(to bottom, transparent, white 10%, white 90%, transparent)`,
        //  border: '7px solid rgba(92, 9, 9, 0.1)',
        // background: "rgba(0, 0, 0, 0.7)",
        // backdropFilter: "blur(5px)",
        //     WebkitBackdropFilter: "blur(5px)",
        // boxShadow: `
        //   0 2px 0 rgba(255, 255, 255, 0.03) inset,
        //   0 -2px 0 rgba(0, 0, 0, 0.5) inset,
        //   0 12px 24px rgba(0, 0, 0, 0.6),
        //   0 32px 64px rgba(0, 0, 0, 0.5),
        //   0 64px 100px rgba(0, 0, 0, 0.35)
        // `,
    }}
  >
    {/* Background video */}
    {/* <video
      autoPlay
      loop
      muted
      playsInline
      style={{
        position: 'absolute',  // ← was fixed
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        zIndex: 0,
      }}
    >
      <source src={`${CF_BASE}/llbg.mp4`} type="video/mp4" />
    </video> */}

    {/* Content sits above video */}
    <h12
      style={{
        position: 'relative',  // ← sits above video
        zIndex: 1,
       
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        borderRadius: "30px",
        border: '3px solid rgba(92, 9, 9, 0.9)',
        background: "rgba(0, 0, 0, 0.7)",
         boxShadow: `
          0 2px 0 rgba(255, 255, 255, 0.03) inset,
          0 -2px 0 rgba(0, 0, 0, 0.5) inset,
          0 12px 24px rgba(0, 0, 0, 0.6),
          0 32px 64px rgba(0, 0, 0, 0.5),
          0 64px 100px rgba(0, 0, 0, 0.35)
        `,
         opacity: text1Visible ? 1 : 0,
    animation: text1Visible ? 'focusIn 2.5s ease forwards' : 'none',
    animationDelay: text1Visible ? '2s' : '0s',
      }}
    >
      Corporate psychopath Nicolas Ortiz violently pursues everyone he deems responsible for his downfall.
      After a chance encounter with an unlikely drug pusher, Nicolas discovers a chemical cocktail that
      significantly enhances his physical and mental state. Mercilessly wielding his newfound herculean abilities,
      he reaps vengeance with ease. But unbeknownst to Nicolas, his actions do not go unnoticed. A lurking figure
      watches from afar to see just how far Nicolas will go, no matter the cost.
    </h12>
  </div>
</div>

     {/* <div className="d-flex justify-content-center">
        <div
          ref={text1Ref}
          style={{
            opacity: text1Visible ? 1 : 0,
            transition: "opacity 0.9s ease",
            transitionDelay: text1Visible ? "2s" : "0s", 
            // background: "rgba(96,85,61,0.7)",
            backdropFilter: "blur(1px)",
            WebkitBackdropFilter: "blur(5px)",
            borderRadius: "30px",
            padding: "0.2rem 0.6rem",
            // marginBottom: '1rem',
          }}
        >
          <h9 style={{ margin: 0}}>Sizzle Reel</h9>
        </div>
      </div> */}

 <div className="netflix-player-wrapper" 
 ref={(el) => {
    wrapperRef.current = el;
    videoWrapperRef.current = el;
  }}
          style={{
             opacity: videoVisible ? 1 : 0,
    transition: 'opacity 0.9s ease',
    //  transitionDelay: videoVisible ? "2s" : "0s", 
        width: '100%',
        maxWidth: '900px',
        margin: '1rem auto',
        // aspectRatio: '16 / 9',
        borderRadius: '8px',
        overflow: 'hidden',
         borderRadius: "30px",
  border: '7px solid rgba(92, 9, 9, 0.9)',
boxShadow: `
  0 2px 0 rgba(255, 255, 255, 0.03) inset,
  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
  0 12px 24px rgba(0, 0, 0, 0.6),
  0 32px 64px rgba(0, 0, 0, 0.5),
  0 64px 100px rgba(0, 0, 0, 0.35)
`,
  maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
        WebkitMaskComposite: 'source-in',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem',
marginBottom: '4rem',
          }}
         >

{showPoster && (
  <div className='hover-brighten'
    onClick={() => {
      const internal = playerRef.current?.getInternalPlayer();
      if (!internal) return;

      internal.play();       // start video
      setShowPoster(false);  // hide poster
    }}

    style={{
      position: 'absolute',
      inset: 0,
      zIndex: 5,
      cursor: 'pointer',
      background: 'rgba(0,0,0,0.2)',
    }}
  >
    <img
      src={trailercover}
      alt="Video poster"
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      }}
    />

    {/* Play icon */}

<div
  style={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    pointerEvents: 'none',
    // backgroundColor: 'silver',
    // opacity: '.6'
  }}
>
<span 
style={{ 
  display: 'flex', 
alignItems: 'center', 
justifyContent: 'center',
// gap: '10px',
width: 116,
      height: 116,
      borderRadius: "50%",
       background: "rgba(116, 12, 12, 0.75)",
      border: "4px solid rgba(216, 209, 209, 0.8)",
 }}>
  <span style={{
    fontFamily: "'Buzzer', sans-serif",
    fontSize: 72,
    lineHeight: 1,
    transform: "rotate(-20deg)",
    display: "inline-block",
    color:  "silver",
    // backgroundColor: 'silver' 
  }}>
    I
  </span>
  <span style={{
    fontFamily: "'Buzzer', sans-serif",
    fontSize: 108,
    lineHeight: 1,
    transform: "rotate(-100deg)",
    display: "inline-block",
    color:  "silver",
    
    
  }}>
    V
  </span>
</span>
</div>
 <div>
    <h10
      style={{
        position: 'absolute',
        bottom: '24px',
        left: '24px',
        color: 'white',
        fontSize: '1.1rem',
        letterSpacing: '0.12em',
        textTransform: 'uppercase',
        pointerEvents: 'none',
        transform: 'translateX(0)',
        opacity: 1,
        animation: videoVisible ? 'slideInLeft 0.7s ease 0.3s both' : 'none',
      }}
    >
      Sizzle Reel
    </h10>
</div>
  </div>
)}





        <ReactPlayer
        ref={playerRef}
        // url={videoUrl} 
        url={`${CF_BASE}/sizzle.mov`}
        controls={isMobile}   
        width="100%"
        height="100%"
        volume={volume}
        muted={muted}
        onPlay={handlePlay}              // ✅ REAL playback
        onPause={handlePause}
        onEnded={handleEnded}
        onProgress={handleProgress}
        onDuration={handleDuration}
        config={{
          file: {
            attributes: {
              playsInline: isMobile,      // ✅ mobile inline, desktop unaffected
        controls: isMobile,         // ✅ REQUIRED for iOS
        disablePictureInPicture: !isMobile,
            }
          }
        }}
      />

{ !isMobile && hasStarted && showControls && (
      <div className="netflix-controls"
      style={{
        bottom: '0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '20px',
        padding: '10px 20px',
        width: '100%',
        maxWidth: '100vw',
        zIndex: 10,
      }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '5%',
            position: 'absolute',
            bottom: '90%',
            width: '100%',
            zIndex: 2,
          }}
         >
          <Button
            onClick={handleRewind15}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              position: 'relative',
              width: '48px',
              height: '48px',
              padding: 0,
              margin: '2%'
            }}
          >
            <RotateCcw
              size={48}
              strokeWidth={2.5}
              style={{
                color: 'silver',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
            <span
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: '14px',
                color: 'white',
                pointerEvents: 'none',
              }}
            >
              15
            </span>
          </Button>

          <Button
            className="center-play-button"
            onClick={togglePlayPause}
            style={{
              backgroundColor: 'transparent',
              color: 'white',
              border: 'none',
              padding: '20px',
              borderRadius: '50%',
              cursor: 'pointer',
              fontSize: '100px',
              zIndex: 2,
            }}
          >
            {isPlaying ? (
              <Pause
                fill="currentColor"
                size={64}
                strokeWidth={2.5}
                style={{
                  color: 'silver',
                }}
              />
            ) : (
              <Play
                fill="currentColor"
                size={64}
                strokeWidth={2.5}
                style={{
                  color: 'silver',
                }}
              />
            )}
          </Button>

          <Button
            onClick={handleForward15}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              position: 'relative',
              width: '48px',
              height: '48px',
              padding: 0,
              margin: '2%'
            }}
          >
            <RotateCw
              size={48}
              strokeWidth={2.5}
              style={{
                color: 'silver',
                position: 'absolute',
                top: 0,
                left: 0,
              }}
            />
            <span
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                fontSize: '14px',
                color: 'white',
                pointerEvents: 'none',
              }}
            >
              15
            </span>
          </Button>
        </div>



      
    <div className="sliders-container"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        width: '100%',
        padding: '0 20px'
      }}>
      <input
        ref={sliderRef}
        className="player-slider"
        type="range"
        min={0}
        max={1}
        step={0.01}
        value={played}
        onChange={(e) => playerRef.current.seekTo(parseFloat(e.target.value))}
        onMouseMove={(e) => {
          if (!sliderRef.current) return;
          const rect = sliderRef.current.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const ratio = x / rect.width;
          const time = ratio * totalTime;
          const timeRemaining = totalTime - (ratio * totalTime);
          setHoverTime(timeRemaining);
          setHoverTime(time);
          setHoverX(x);
        }}
        onMouseLeave={() => {
          setHoverTime(null);
          setHoverX(null);
        }}
        style={{ '--played': played }}
      />
      {hoverTime !== null && (
          <div
            className="slider-tooltip"
            style={{
              left: `${hoverX}px`
            }}
          >
            {formatTime(hoverTime)}
          </div>
        )}
        <div className="time-display">
        <CardText>
          {formatTime(currentTime)}/{formatTime(totalTime)}
        </CardText>
        </div>
        
        <div
        style={{ position: 'relative', cursor: 'pointer', display: 'inline-block' }}
        onMouseEnter={() => {
          clearTimeout(hideTimeoutRef.current);
          setShowVolumeSlider(true);
        }}
        onMouseLeave={() => {
          hideTimeoutRef.current = setTimeout(() => {
            setShowVolumeSlider(false);
          }, 300);
        }}
      >
        {muted ? (
          <VolumeX 
            color="silver" 
            size={24}
            onClick={toggleMute}
          />
        ) : (
          <Volume2 
            color="silver" 
            size={24}
            onClick={toggleMute}
          />
        )}

        {showVolumeSlider && (
          <input
            type="range"
            min={0}
            max={1}
            step={0.05}
            value={volume}
            onChange={(e) => {
              const newVolume = parseFloat(e.target.value);
              setVolume(newVolume);
              if (newVolume === 0) {
                setMuted(true);
              } else {
                setMuted(false);
              }
            }}
            className="custom-slider volume-slider"
            style={{
              position: 'absolute',
              bottom: '80px',
              left: '50%',
              transform: 'translateX(-50%) rotate(-90deg)',
              width: '100px',
              height: '8px',
              zIndex: 10,
              '--progress': `${volume * 100}%`
            }}
            onClick={(e) => e.stopPropagation()}
          />
        )}
      </div>

      <div
        style={{ position: 'relative', cursor: 'pointer', display: 'inline-block', marginLeft: '1%' }}
        onClick={handleToggleFullscreen}
        title={isFullscreen ? "Exit Fullscreen" : "Fullscreen"}
      >
        {isFullscreen ? (
          <Minimize color="silver" size={24} />
        ) : (
          <Maximize color="silver" size={24} />
        )}
      </div>

        </div>
        
      </div>
      )}
    </div>  

        <div className="d-flex justify-content-center">
        <div
          ref={storyRef}
          style={{
            opacity: storyVisible ? 1 : 0,
            transition: "opacity 0.9s ease",
            // background: "rgba(96,85,61,0.7)",
            backdropFilter: "blur(1px)",
            WebkitBackdropFilter: "blur(5px)",
            borderRadius: "30px",
            // padding: "0.2rem 0.6rem",
            // marginBottom: '1rem',
          }}
        >
          <h9 style={{ margin: 0, color: "white" }}>The Story</h9>
        </div>
      </div>

<div className="d-flex justify-content-center">
  <div 
    ref={storyRef}
   style={{
  opacity: storyVisible ? 1 : 0,
  transition: "opacity 0.9s ease",
  marginBottom: '7rem',
  width: '100%',
  maxWidth: '1000px',
  backgroundImage: `url(${redbg})`,
  backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
  borderRadius: "30px",
  border: '7px solid rgba(92, 9, 9, 0.9)',
boxShadow: `
  0 2px 0 rgba(255, 255, 255, 0.03) inset,
  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
  0 12px 24px rgba(0, 0, 0, 0.6),
  0 32px 64px rgba(0, 0, 0, 0.5),
  0 64px 100px rgba(0, 0, 0, 0.35)
`,
  maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
        WebkitMaskComposite: 'source-in',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem',
}}
  >

    {/* Paragraph 1 — Nicolas at his lowest */}
    <div
    ref={story1Ref}
    style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
     
      width: '100%',
      // maxWidth: '900px',
      flexWrap: 'wrap',
       opacity: story1Visible ? 1 : 0,
    transform: story1Visible ? 'translateY(0)' : 'translateY(30px)',
    transition: 'opacity 0.9s ease, transform 0.9s ease',
    }}>
      <div style={{ 
        position: 'relative', 
        flex: '0 0 280px', 
        borderRadius: '16px', 
        overflow: 'hidden',
        borderRadius: '36px',
          maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
        WebkitMaskComposite: 'source-in',
        }}>
        <img
          src={broken}
          alt="Nicolas at his lowest"
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(to right, transparent 60%, rgba(20,19,19,0.9) 100%)',
        }} />
      </div>
           <div style={{ flex: 1, minWidth: '250px', display: 'flex', flexDirection: 'column' }}>
     <h11
      style={{
        display: 'block',
        padding: '0.75rem 0.75rem 0',
        textDecoration: 'underline',
        textDecorationColor: 'rgba(92, 9, 9, 0.9)',
        textDecorationThickness: '3px',
        textUnderlineOffset: '6px',
      }}
    >
      Defeated yet Undeterred
    </h11>
        <CardText style={{
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
          borderRadius: '16px',
          color: 'white',
          margin: 0,
          padding: '0.5rem',
          textShadow: '0 1px 4px rgba(0,0,0,0.8)',
        }}>
          A once well to do man, Nicolas Ortiz is a despondent, impoverished hermit, unrecognizable to 
          everyone who's ever known him. Following the death of his brother, Rodrigo, Nicolas' life 
          began to crumble, a snowball of tragic events unfolded. Nicolas was laid off from his lucrative 
          fintech job at a prestigious firm, his fiancé Evelyn ended their engagement, and his 
          multi-acre property was foreclosed on and sold to a commercial land developer.  Nicolas receded into himself and, finally, one day, snaps, endeavoring to kill 
          the person responsible for each event's outcome. Burning with a passionate revenge, 
          Nicolas inserts himself into dangerous situations to increase the likelihood of 
          coming face to face with those he deems worthy of his self-serving justice.
        </CardText>
      </div>
    </div>

    {/* Paragraph 2 — The Snap */}
    <div 
    ref={story2Ref}
    style={{
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'center',
      gap: '1rem',
      width: '100%',
      // maxWidth: '900px',
      flexWrap: 'wrap',
       opacity: story2Visible ? 1 : 0,
    transform: story2Visible ? 'translateY(0)' : 'translateY(30px)',
    transition: 'opacity 0.9s ease, transform 0.9s ease',
    }}>
      <div style={{ 
        position: 'relative', 
        flex: '0 0 280px', 
        borderRadius: '16px', 
        overflow: 'hidden',
        borderRadius: '36px',
          maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
        WebkitMaskComposite: 'source-in',
        }}>
        <img
          src={drug}
          alt="Nicolas snaps"
          style={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }}
        />
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(to left, transparent 60%, rgba(20,19,19,0.9) 100%)',
        }} />
      </div>
             <div style={{ flex: 1, minWidth: '250px', display: 'flex', flexDirection: 'column' }}>
        <h11 
         style={{
          display: 'block',
          padding: '0.75rem 0.75rem 0',
          textDecoration: 'underline',
          textDecorationColor: 'rgba(92, 9, 9, 0.9)',
          textDecorationThickness: '3px',
          textUnderlineOffset: '6px',
        }}
        >
          Death of a Brother
        </h11>
      <CardText style={{
        // backgroundColor: 'rgba(20, 19, 19, 0.3)',
         backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)', 
        borderRadius: '16px',
        flex: 1,
        minWidth: '250px',
        color: 'white',
        margin: 0,
        padding: '0.50rem',
        textShadow: '0 1px 4px rgba(0,0,0,0.8)',
      }}>
          Nicolas’ bloodthirsty adventure begins with “The Alchemist”, the former CEO of the small, 
          now defunct pharmaceutical firm Alcot. The manufacturer of the experimental drug TRT723, a 
          therapy purposed to treat muscular dystrophy, Alcot recruited Nicolas’ brother, Rodrigo, for 
          clinical trials. Suffering from a terminal form of the disease, Rodrigo’s rapidly declining 
          physical state became so severe that Rodrigo desperately sought to stifle the diseases 
          progression. TRT723 was the answer, Rodrigo enrolled. The treatment was successful but short 
          lived. Rodrigo died alone and in immense pain, 5 weeks into treatment. 
      </CardText>
      </div>
    </div>

    {/* Paragraph 3 — The Drug */}
    <div 
    ref={story3Ref}
    style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '1rem',
      width: '100%',
      // maxWidth: '900px',
      flexWrap: 'wrap',
       opacity: story3Visible ? 1 : 0,
    transform: story3Visible ? 'translateY(0)' : 'translateY(30px)',
    transition: 'opacity 0.9s ease, transform 0.9s ease',
    }}>
      <div style={{ position: 'relative', flex: '0 0 280px', borderRadius: '16px', overflow: 'hidden' }}>
        <img
          src={closeup}
          alt="The drug discovery"
          style={{ 
            width: '100%', 
            height: '200px', 
            objectFit: 'cover', 
            display: 'block',
            borderRadius: '36px',
              maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
        WebkitMaskComposite: 'source-in',
          }}
        />
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(to right, transparent 60%, rgba(20,19,19,0.9) 100%)',
        }} />
      </div>
      <div style={{ flex: 1, minWidth: '250px', display: 'flex', flexDirection: 'column' }}>
        <h11 
        style={{
          display: 'block',
          padding: '0.75rem 0.75rem 0',
          textDecoration: 'underline',
          textDecorationColor: 'rgba(92, 9, 9, 0.9)',
          textDecorationThickness: '3px',
          textUnderlineOffset: '6px',
        }}
           >
          Revenge and Retribution
        </h11>
      <CardText style={{
        // backgroundColor: 'rgba(20, 19, 19, 0.3)',
         backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)', 
        borderRadius: '16px',
        flex: 1,
        minWidth: '250px',
        color: 'white',
        margin: 0,
        padding: '0.50rem',
        textShadow: '0 1px 4px rgba(0,0,0,0.8)',
      }}>
        Although Alcot no longer exists and its products are no longer sold, Nicolas learns of the Silk Road, 
        an underground drug trafficking economy buried deep in the digital world. With the help of a distant 
        childhood friend Nicolas infiltrates this community, acquaints himself with a high-profile buyer of 
        TRT723 and is made an offer: deliver a briefcase to a TRT723 dealer in exchange for $25K. A highly 
        suspicious rate for such a transaction, Nicolas accepts the offer because, despite the inherent risk, 
        he must find and kill the man responsible for his brother’s death, a man he calls The Alchemist…
      </CardText>
      </div>
    </div>

      {/* <div 
    ref={story4Ref}
    style={{
      display: 'flex',
      flexDirection: 'row-reverse',
      alignItems: 'center',
      gap: '1rem',
      width: '100%',
      // maxWidth: '900px',
      flexWrap: 'wrap',
       opacity: story4Visible ? 1 : 0,
    transform: story4Visible ? 'translateY(0)' : 'translateY(30px)',
    transition: 'opacity 0.9s ease, transform 0.9s ease',
    }}>
      <div style={{ 
        position: 'relative', 
        flex: '0 0 280px', 
        borderRadius: '16px', 
        overflow: 'hidden',
        borderRadius: '36px',
          maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
        WebkitMaskComposite: 'source-in',
        }}>
        <img
          src={hero}
          alt="Nicolas snaps"
          style={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }}
        />
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(to left, transparent 60%, rgba(20,19,19,0.9) 100%)',
        }} />
      </div>
      <CardText style={{
         backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)', 
        borderRadius: '16px',
        flex: 1,
        minWidth: '250px',
        color: 'white',
        margin: 0,
        padding: '0.75rem',
        textShadow: '0 1px 4px rgba(0,0,0,0.8)',
      }}>
        But soon after he embarks on this crusade, he finds a remarkable drug that gives him unbelievable 
        physical strength, further fueling his indefatigable conviction. However, after his revelation of 
        man's Herculean potential a suspicious lurker begins to follow Nicolas, a fact to which he is unaware.
      </CardText>
    </div> */}
  </div>
</div>

   <div className="d-flex justify-content-center">
        <div
          ref={moodRef}
          style={{
            opacity: moodVisible ? 1 : 0,
            transition: "opacity 0.9s ease",
            backdropFilter: "blur(1px)",
            WebkitBackdropFilter: "blur(5px)",
            borderRadius: "30px",
          }}
        >
          <h9 style={{ margin: 0,}}>Concept Art</h9>
        </div>
      </div>

<div
   ref={moodRef}
    style={{
      opacity: moodVisible ? 1 : 0,
      transition: "opacity 0.9s ease",
      width: '100%',
      maxWidth: '1000px',
         maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
        WebkitMaskComposite: 'source-in',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1rem',
      margin: '0rem auto 5rem auto',
    }}
>
  <FilmCarousel images={[
  
   { src: broken, caption: "The Broken Man" },
   { src: drugdeal, caption: "A Fateful Exchange" },
  { src: drug, caption: "Nicolas' Awakening" },
  { src: hero, caption: "Revitalized Revenge" },
  { src: brawl, caption: "Settling Scores" },
  { src: darkfigure, caption: "The Omnipresent Observer" },
  { src: closeup, caption: "A Relentless Vengeance" },
]} 
active={moodVisible}
/>
</div>

    <div className="d-flex justify-content-center">
        <div
          ref={castRef}
          style={{
            opacity: castVisible ? 1 : 0,
            transition: "opacity 0.9s ease",
            // background: "rgba(96,85,61,0.7)",
            backdropFilter: "blur(1px)",
            WebkitBackdropFilter: "blur(5px)",
            borderRadius: "30px",
            // padding: "0.2rem 0.6rem",
            // marginBottom: '1rem',
          }}
        >
          <h9 style={{ margin: 0, color: "white" }}>The Characters</h9>
        </div>
      </div>

<div className="d-flex justify-content-center">
  <div
    ref={castRef}
    style={{
      opacity: castVisible ? 1 : 0,
      transition: "opacity 0.9s ease",

        backgroundImage: `url(${redbgf})`, 
        borderRadius: "30px",
        border: '7px solid rgba(92, 9, 9, 0.9)',
boxShadow: `
  0 2px 0 rgba(255, 255, 255, 0.03) inset,
  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
  0 12px 24px rgba(0, 0, 0, 0.6),
  0 32px 64px rgba(0, 0, 0, 0.5),
  0 64px 100px rgba(0, 0, 0, 0.35)
`,
  maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
        WebkitMaskComposite: 'source-in',
          transform: 'perspective(1200px) rotateX(2.5deg)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '1rem',
          padding: "1rem 2rem", 
          marginBottom: '7rem',
          textAlign: 'center', 
          width: '100%',
          maxWidth: '1000px',
    }}
  >
    <CardText>
  Our characters are ruthless, cunning, and utterly without remorse. Now it's your turn to
  cast them. Have an actor in mind? Upload their photo, generate a still, and watch your
  vision come to life!
</CardText>

    <div className="team-grid">
  <FlipCard
    src={Nico}
    alt="Nicolas"
    character="nicolas"
    name='"Nicolas"'
    role="Avenger"
    description="Abandoned by his wife, structurally unemployed, and robbed of his property, 
    Nicolas embarks on a violently criminal crusade after suffering the loss of his younger brother,
    Rodrigo. Despite his to seemingly noble effort to dispatch these evil doers, Nicolas himself 
    posseses a melevolent nature. He is one of them. Just unlucky enough to get fucked by a system for which 
  he previously thrived in."
  />
  <FlipCard
    src={Kent}
    alt="Kent"
     character="kent"
    name='"Kent"'
    role="Chemist"
    description="Former PhD student and aspiring academic. Renowned for their work in organic chemistry, 
    Kent is lured into the criminal underworld by the promise of quick money to fund his research. However,
    he soon realizes he's out of his depth and finds himself caught in Nicolas' web of violence. He either
    continues producing the substance Nicolas' relies on to carry out his evil acts, or risks becoming a victim
    himself."
  />
  <FlipCard
    src={Rodrigo}
    alt="Rodrigo"
     character="rodrigo"
    name='"Rodrigo"'
    role="Mastermind"
    description="Nicolas' estranged, twin brother and pharmaceutical entrepreneur. Like Nicolas, Rodrigo
    posseses a sociopathic nature but, unlike Nicolas, choose a life of crime in pursuit of his money-making 
    ambitions. Unbeknownst to Nicholas, Rodrigo is the mastermind behind the drug that gives Nicolas his 
    superhuman strength, and is the one responsible for their brother, Tono's, death."
  />
</div>


       
  </div>
</div>


    <div className="d-flex justify-content-center">
        <div
          ref={marketRef}
          style={{
            opacity: marketVisible ? 1 : 0,
            transition: "opacity 0.9s ease",
            // background: "rgba(96,85,61,0.7)",
            backdropFilter: "blur(1px)",
            WebkitBackdropFilter: "blur(5px)",
            borderRadius: "30px",
            // padding: "0.2rem 0.6rem",
            // marginBottom: '1rem',
          }}
        >
          <h9 style={{ margin: 0, color: "white" }}>The Market</h9>
        </div>
      </div>



<div className="d-flex justify-content-center">
  <div
    ref={marketRef}
    style={{
      opacity: marketVisible ? 1 : 0,
      transition: "opacity 0.9s ease",
      padding: "1rem 2rem",
      maxWidth: "1100px",
      width: "100%", 
      backgroundColor: 'rgba(20, 19, 19, 0.7)',
      backgroundImage: `url(${redbg})`, 
           borderRadius: "30px",
        border: '7px solid rgba(92, 9, 9, 0.9)',
boxShadow: `
  0 2px 0 rgba(255, 255, 255, 0.03) inset,
  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
  0 12px 24px rgba(0, 0, 0, 0.6),
  0 32px 64px rgba(0, 0, 0, 0.5),
  0 64px 100px rgba(0, 0, 0, 0.35)
`,
  maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
          transform: 'perspective(1200px) rotateX(2.5deg)',
      marginBottom: '7rem',

    }}
  >
     {/* <h9 className="d-flex justify-content-center" style={{ margin: 0, color: "white" }}>The Market</h9> */}
           {/* <CardText>
  Lucky Bastards is an action-driven heist film following a crew of lifelong hustlers who accidentally steal one of the most infamous cars in history - James Dean’s long-lost Porsche 550 Spyder - and spark a citywide underworld war. Unlike polished pros in typical heist films, these aren’t experts - they’re reckless underachievers whose screw-up becomes legend.
With global appeal, a multicultural cast, high-octane set pieces, dark comedy, and a surreal third act twist, the film delivers both chaos and character. The cursed relic, the rising body count, and a billionaire buyer with assassin backup push the genre into bold, absurd territory.
It’s built for franchise potential, fueled by visual spectacle, dark web mystique, and characters you can’t help but root for - even if they might accidentally get you killed.
    </CardText> */}


 <div 
  ref={donutRef}
  style={{ 
    width: "100%", 
    maxWidth: "1000px", 
    marginTop: '1rem',
    marginBottom: '2rem',
    // borderRadius: '10px',
    borderBottom: '3px solid rgba(92, 9, 9, 0.9)',
    paddingBottom: '2rem',
     backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)', 
  }}>
  <div style={{ height: 320,  }}>
    {donutVisible && <StoryDonut />}
  </div>
</div>

     <div 
     ref={revenueRef}
     style={{ 
       width: "100%", 
    maxWidth: "1000px", 
    marginTop: '1rem',
    marginBottom: '2rem',
    borderBottom: '3px solid rgba(92, 9, 9, 0.9)',
    paddingBottom: '2rem',
     backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)', 
   
      }}>
        <div style={{ height: 370,  }}>
          {revenueVisible && <ActionRevenueLineGraph />}
        </div>
     
    </div>

      <div 
      ref={domsvsintRef}
       style={{ 
          width: "100%", 
    maxWidth: "1000px", 
    marginTop: '1rem',
    marginBottom: '2rem',
    borderBottom: '3px solid rgba(92, 9, 9, 0.9)',
    paddingBottom: '1rem',
     backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)', 
    }}
      >
        <div style={{ height: 370,  }}>
          {domsvsintVisible && <DomesticVsInternational />}
        </div>
    </div>

     <div 
     ref={compsRef}
     style={{ 
      width: "100%", 
      maxWidth: "1000px", 
      height: 350,
        backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)', 
      }}>
      {compsVisible && <CompsChart />}
    </div>
  </div>
</div>




      <div className="d-flex justify-content-center">
        <div
            ref={partnerRef}
          style={{
            opacity: partnerVisible ? 1 : 0,
            transition: "opacity 0.9s ease",
            // background: "rgba(96,85,61,0.7)",
            // backdropFilter: "blur(1px)",
            // WebkitBackdropFilter: "blur(5px)",
            borderRadius: "30px",
            // padding: "0.2rem 0.6rem",
            // marginBottom: '1rem',
          }}
        >
          <h9 style={{ margin: 0, color: "white" }}>Raise and Use of Funds</h9>
        </div>
      </div>

      <div
       ref={partnerRef}
      style={{ 
        opacity: partnerVisible ? 1 : 0,
        display: 'flex',          
        justifyContent: 'center',
        backgroundImage: `url(${redbg})`, 
        borderRadius: "30px",
        border: '7px solid rgba(92, 9, 9, 0.9)',
        boxShadow: `
          0 2px 0 rgba(255, 255, 255, 0.03) inset,
          0 -2px 0 rgba(0, 0, 0, 0.5) inset,
          0 12px 24px rgba(0, 0, 0, 0.6),
          0 32px 64px rgba(0, 0, 0, 0.5),
          0 64px 100px rgba(0, 0, 0, 0.35)
        `,
        maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
        transform: 'perspective(1200px) rotateX(2.5deg)',
        maxWidth: "1100px", 
        width: '100%',
        margin: '0 auto', 
        marginBottom: '8rem',
  }}>


  <div style={{ width: '100%', }}>
   {partnerVisible && <UseOfFundsDonut />}
  </div>

  
  

  {/* <div className="card-wrapper">
    <div className="about-us-card"
      style={{
      padding: ".5rem",
      
      }}
    >
  <h2 style={{ margin: '0.5rem 0 0 0', fontWeight: 'bold' }}>Budget</h2>
  
     <CardText style={{ padding: '0.6rem', textAlign: 'left' }}>
      Budget is $30 million with much of the costs offset through partnerships with local brands. 
      Combining this with our ability to produce films on lean budgets, we’re confident in our ability 
      to maximize every dollar and deliver a visually stunning, commercially successful film.
    </CardText>
     <div ref={sectionRef} style={{ display: "flex", gap: "3rem", justifyContent: "center" }}>
      <Dial label="Budget" max={500000} format={v => '$' + Math.round(v).toLocaleString()} color="#378ADD" targetProgress={triggered ? 1 : 0} />
    </div>
    </div>
  </div> */}
      {/* <div >
    <div 
      style={{
    
      marginBottom: '1rem',
        backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)', 
      }}
    >
  <h2 style={{ margin: '0.5rem 0 0 0', fontWeight: 'bold' }}>Tax Incentives</h2>
     <CardText style={{ padding: '0.6rem', textAlign: 'left' }}>
      Due to the shooting location, local partnerships and utilization of local cast and crew, we 
      qualify for a 30% tax credit on qualified expenditures, which significantly reduces our 
      effective budget and increases our potential return on investment.
    </CardText>
     <div ref={sectionRef} style={{ display: "flex", gap: "3rem", justifyContent: "center" }}>
      <Dial label="Score" max={9.8} format={v => v.toFixed(1)} color="#D85A30" targetProgress={triggered ? 1 : 0} />
    </div>
    </div>
  </div> */}


  {/* <div className="card-wrapper">
    <div className="about-us-card"
      style={{
      padding: ".5rem",
      
      }}
    >
  <h2 style={{ margin: '0.5rem 0 0 0', fontWeight: 'bold' }}>Revenue</h2>
     <CardText style={{ padding: '0.6rem', textAlign: 'left' }}>
      Revenue will be generated through our proprietary sales mechanism which
      enables users to select items they're interested in the film and purchase them directly through our app. This innovative 
      approach not only creates a new revenue stream but also enhances audience engagement and opens up exciting partnership opportunities with brands.
      
    </CardText>
     <div ref={sectionRef} style={{ display: "flex", gap: "3rem", justifyContent: "center" }}>
      <Dial label="Completion" max={100} format={v => Math.round(v) + '%'} color="#1D9E75" targetProgress={triggered ? 1 : 0} />
    </div>
    </div>
  </div> */}

  

      </div>

            <div className="d-flex justify-content-center">
        <div
            ref={partnerRef}
          style={{
            opacity: partnerVisible ? 1 : 0,
            transition: "opacity 0.9s ease",
            // background: "rgba(96,85,61,0.7)",
            // backdropFilter: "blur(1px)",
            // WebkitBackdropFilter: "blur(5px)",
            borderRadius: "30px",
            // padding: "0.2rem 0.6rem",
            // marginBottom: '1rem',
          }}
        >
          <h9 style={{ margin: 0, color: "white" }}>Financial Projections</h9>
        </div>
      </div>

      <div 
       ref={partnerRef}
      style={{ 
        opacity: partnerVisible ? 1 : 0,
        display: 'flex',          
        justifyContent: 'center',
  //  backgroundColor: 'rgba(20, 19, 19, 0.7)',
    backgroundImage: `url(${redbg})`, 
      // backdropFilter: 'blur(3px)',
      // WebkitBackdropFilter: 'blur(8px)', 
   borderRadius: "30px",
    border: '7px solid rgba(92, 9, 9, 0.9)',
        boxShadow: `
          0 2px 0 rgba(255, 255, 255, 0.03) inset,
          0 -2px 0 rgba(0, 0, 0, 0.5) inset,
          0 12px 24px rgba(0, 0, 0, 0.6),
          0 32px 64px rgba(0, 0, 0, 0.5),
          0 64px 100px rgba(0, 0, 0, 0.35)
        `,
        maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
          transform: 'perspective(1200px) rotateX(2.5deg)',
            maxWidth: "1000px", 
             margin: '0 auto', 
             marginBottom: '8rem',
  }}>

    <div className="card-wrapper" 
    style={{ 
      gridColumn: '1 / -1',
       marginBottom: '2rem',
       width: "100%",
       maxWidth: "900px", 
        margin: '0 auto 0rem auto',
          backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)', 
    // borderBottom: '1px solid rgba(243, 61, 61, 0.7)',
    // paddingBottom: '1rem',
      }}
      >
  <div className="about-us-card" style={{ padding: ".5rem", marginBottom: '1rem', width: "100%", }}>
   {partnerVisible && <FinancialProjections />}
  </div>

  
  
</div>
  {/* <div className="card-wrapper">
    <div className="about-us-card"
      style={{
      padding: ".5rem",
      
      }}
    >
  <h2 style={{ margin: '0.5rem 0 0 0', fontWeight: 'bold' }}>Budget</h2>
  
     <CardText style={{ padding: '0.6rem', textAlign: 'left' }}>
      Budget is $30 million with much of the costs offset through partnerships with local brands. 
      Combining this with our ability to produce films on lean budgets, we’re confident in our ability 
      to maximize every dollar and deliver a visually stunning, commercially successful film.
    </CardText>
     <div ref={sectionRef} style={{ display: "flex", gap: "3rem", justifyContent: "center" }}>
      <Dial label="Budget" max={500000} format={v => '$' + Math.round(v).toLocaleString()} color="#378ADD" targetProgress={triggered ? 1 : 0} />
    </div>
    </div>
  </div> */}
      {/* <div >
    <div 
      style={{
    
      marginBottom: '1rem',
        backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)', 
      }}
    >
  <h2 style={{ margin: '0.5rem 0 0 0', fontWeight: 'bold' }}>Tax Incentives</h2>
     <CardText style={{ padding: '0.6rem', textAlign: 'left' }}>
      Due to the shooting location, local partnerships and utilization of local cast and crew, we 
      qualify for a 30% tax credit on qualified expenditures, which significantly reduces our 
      effective budget and increases our potential return on investment.
    </CardText>
     <div ref={sectionRef} style={{ display: "flex", gap: "3rem", justifyContent: "center" }}>
      <Dial label="Score" max={9.8} format={v => v.toFixed(1)} color="#D85A30" targetProgress={triggered ? 1 : 0} />
    </div>
    </div>
  </div> */}


  {/* <div className="card-wrapper">
    <div className="about-us-card"
      style={{
      padding: ".5rem",
      
      }}
    >
  <h2 style={{ margin: '0.5rem 0 0 0', fontWeight: 'bold' }}>Revenue</h2>
     <CardText style={{ padding: '0.6rem', textAlign: 'left' }}>
      Revenue will be generated through our proprietary sales mechanism which
      enables users to select items they're interested in the film and purchase them directly through our app. This innovative 
      approach not only creates a new revenue stream but also enhances audience engagement and opens up exciting partnership opportunities with brands.
      
    </CardText>
     <div ref={sectionRef} style={{ display: "flex", gap: "3rem", justifyContent: "center" }}>
      <Dial label="Completion" max={100} format={v => Math.round(v) + '%'} color="#1D9E75" targetProgress={triggered ? 1 : 0} />
    </div>
    </div>
  </div> */}

  

      </div>

          <div className="d-flex justify-content-center">
        <div
          ref={teamRef}
          style={{
            opacity: teamVisible ? 1 : 0,
            transition: "opacity 0.9s ease",
            // background: "rgba(96,85,61,0.7)",
          
            borderRadius: "30px",
            // padding: "0.2rem 0.6rem",
            // marginBottom: '1rem',
          }}
        >
          <h9 style={{ margin: 0, color: "white" }}>Production Team</h9>
        </div>
      </div>


        <div
          ref={teamRef}
            style={{
              width: "100%", 
      maxWidth: "800px", 
      margin: '0 auto',
              marginBottom: '6rem',                      
              backgroundColor: 'rgba(20, 19, 19, 0.9)',
               backgroundImage: `url(${redbgf})`, 
        
    //           opacity: teamVisible ? 1 : 0,
    //                       animation: teamVisible ? 'focusIn 2.5s ease forwards' : 'none',
    // animationDelay: teamVisible? '2s' : '0s',
            transition: "opacity 0.9s ease",
    borderRadius: "30px",
 border: '7px solid rgba(92, 9, 9, 0.9)',
        boxShadow: `
          0 2px 0 rgba(255, 255, 255, 0.03) inset,
          0 -2px 0 rgba(0, 0, 0, 0.5) inset,
          0 12px 24px rgba(0, 0, 0, 0.6),
          0 32px 64px rgba(0, 0, 0, 0.5),
          0 64px 100px rgba(0, 0, 0, 0.35)
        `,
        maskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                    linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        WebkitMaskImage: `linear-gradient(to right, transparent, white 2%, white 98%, transparent), 
                          linear-gradient(to bottom, transparent, white 2%, white 98%, transparent)`,
        maskComposite: 'intersect',
          transform: 'perspective(1200px) rotateX(2.5deg)',
                                 
            }}
          >

            <div 
            style={{ 
              padding: '1rem 2%', 
              maxWidth: '750px', 
              margin: '0 auto',
                backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)',  
    //         animation: teamVisible ? 'focusIn 2.5s ease forwards' : 'none',
    // animationDelay: teamVisible? '2s' : '0s',
              }}>
            <TeamRevealCard
              src={Nick}
              alt="Nicholas Ortiz"
              name="Nicholas Ortiz"
              role="Director / Producer"
              description="Nicholas is the Chief Technology Officer of Robert Rodriguez's Brass Knuckle Films, an Austin-based Actor whose most recent role is in SpyKids: Armageddon, and a Producer at Austin Film Society. Aware that many shows filmed in Texas are comprised of cast and crew not local to the state, Nicholas has endeavored to improve the visibility of the local film community."
            />
            {/* <TeamRevealCard
              src={Nick}
              alt="Scott Condit"
              name="Scott Condit"
              role="Writer / Producer"
              description="Your description here..."
            />
            <TeamRevealCard
              src={Nick}
              alt="Ed Gardner"
              name="Ed Gardner"
              role="Producer"
              description="Your description here..."
            /> */}
          </div>
   
          </div>




   {/* <div className="d-flex justify-content-center">
        <div
           ref={schedRef}
          style={{
            opacity: schedVisible ? 1 : 0,
            transition: "opacity 0.9s ease",
            // background: "rgba(96,85,61,0.7)",
      //        backdropFilter: 'blur(3px)',
      // WebkitBackdropFilter: 'blur(8px)', 
            borderRadius: "30px",
            padding: "0.2rem 0.6rem",
            // marginBottom: '1rem',
          }}
        >
          <h9 style={{ margin: 0, color: "white" }}>Production Schedule</h9>
        </div>
      </div> */}
{/* <div className="d-flex justify-content-center">
  <div
    style={{
      opacity: schedVisible ? 1 : 0,
      transition: "opacity 0.9s ease",
      // background: "rgba(96,85,61,0.7)",
      borderRadius: "30px",
      // padding: "1rem 2rem",
      marginBottom: "2rem",
      maxWidth: "1000px",
      width: "100%",
      backgroundColor: 'rgba(20, 19, 19, 0.7)',
       backgroundImage: `url(${redbgf})`, 
       backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)', 
            border: '2px solid rgb(244, 236, 222, .35)',
            boxShadow: `
              0 0 8px rgba(243, 61, 61, 0.6),
              
               0 0 20px rgba(116, 12, 12, 0.35)
            `,
            borderRadius: "30px",
      
    }}
  >
    <div style={{ width: "100%", height: 400 }}>
      
      {compsVisible && <AnimatedGanttChart />}
    </div>
  </div>
</div>
       */}
    </div>
  );
}